import React, { useState, useEffect, useRef } from 'react'
import { HomeIcon, PencilIcon, BuildingLibraryIcon, UserCircleIcon } from '@heroicons/react/24/outline';
import { 
  ButtonGroup, 
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography, 
  Textarea,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Input,
  Spinner,
  IconButton,
  Slider,
  Select, 
  Option,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Tooltip
} from "@material-tailwind/react";

import toast, { Toaster } from 'react-hot-toast';
import checkImg from '../../assets/imgs/check.png';
import { useSelector, useDispatch } from 'react-redux';

import { useWallet, useWallets } from '@wallet-standard/react';
import { getFeeRate, isValidTaprootAddress } from '../../util/inscribe-util';

export default function ValidateAddress() {
  const divRef = useRef(null);

  const { wallets } = useWallets();

  const SatsConnectNamespace = 'sats-connect:';

  const isSatsConnectCompatibleWallet = (wallet) => {
      return SatsConnectNamespace in wallet.features;
  }

  const wallet = useSelector(state => state.wallet);

  const { Address, Script, Signer, Tap, Tx } = window.tapscript;
  const feeRateTabs = ["Slow", "Normal", "Fast", "Custom"];

  const [feeRateMode, setFeeRateMode] = useState("Normal");
  const [feerate, setFeerate] = useState(0);
  const [feeRates, setFeeRates] = useState({});

  const [loading, setLoading] = useState(false);
  const [customFee, setCustomFee] = useState(0);
  const [sliderValue, setSliderValue] = useState(2);

  const [addresses, setAddresses] = useState([]);
  const [isValid, setIsValid] = useState(false);
  const [validDatas, setValidDatas] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [ticker, setTicker] = useState("");
  const [balance, setBalance] = useState(0);
  const [decimal, setDecimal] = useState(8);
  const [show, setShow] = useState(false);
  const [showMint, setShowMint] = useState(false);
  const [inscriptionStatus, setInscriptionStatus] = useState(false);
  const [receiveAddress, setReceiveAddress] = useState("");
  const [mintText, setMintText] = useState("");
  const [feeValues, setFeeValues] = useState({});

  const [textareaText, setTextareaText] = useState("");

  useEffect(() => {
    let value = (sliderValue / 100) * (500 - feeRates["Normal"]) + feeRates["Normal"];
    setCustomFee(Math.floor(value));
  }, [sliderValue])

  const checkValidateAddress = () => {
    // const content = divRef.current.innerHTML;
    // const cleanedContent = content
    //                             .replace(/<div>/g, '@')
    //                             .replace(/<\/div>/g, '@')
    //                             .replace(/<br>/g, '@')
    //                             .replace(/\n/g, '@')
    //                             .replace(/\s+/g, '');
    // let datas = cleanedContent.split("@");
    if (ticker == "") {
      toast.error("Please insert ticker!");
      return;
    }
    if (balance == "" || balance < 0) {
      toast.error("Please insert total amount!");
      return;
    }

    let datas = textareaText.split("\n");

    let temp = [];
    let tempValid = [];
    let total = 0;
    let historyAddresses = [];

    for(let data of datas) {
      let address = "";
      let amount = 1;
      if (data.trim() != "") {
        if (data.includes(",")) {
          let tempArr = data.split(",");
          address = tempArr[0];
          amount = parseInt(tempArr[1]);
        }
        else {
          address = data;
        }
        if (!isValidTaprootAddress(address) && !address.startsWith("bc1q")){
          temp.push(address);
        } else {
          let flag = 0;
          for(let tep of historyAddresses) {
            if (tep == address.trim()) {
              flag = 1;
              break;
            }
          }
          if (flag == 0) {
            tempValid.push({
              address: address.trim(),
              amount: amount
            })
            total = total + amount;
            historyAddresses.push(address.trim())
          }
        }
      }
    }
    
    setAddresses(temp);
    
    if (tempValid.length > 0) 
      setIsValid(true); 
    else 
      setIsValid(false);

    setValidDatas(tempValid);
    setTotalAmount(total);
    console.log(tempValid);
    console.log(total);

    let res = ""

    let textData = {};
    const textItems = [];
    for(let data of tempValid) {
      let tempAmount = Math.floor(data.amount / total * balance * Math.pow(10, decimal)) / Math.pow(10, decimal);
      res = res + data.address + ", " + tempAmount + '\n';
      textItems.push({
        tick: ticker,
        amt: tempAmount.toString(),
        address : data.address
      })
    }

    textData = {
      p: "tap",
      op: "token-send",
      items: textItems
    }
  
    setMintText(JSON.stringify(textData));
    setTextareaText(res);
  }

  const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  const handleDownload = () => {
    const blob = new Blob([mintText], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'token.json';
    a.click();
    URL.revokeObjectURL(url);
    toast.success("Download success!");
  }
  return (
    <div className="flex flex-col gap-5 md:p-5 p-3 min-h-[100vh] w-full items-center">
      <span className="bg-primary text-white sm:text-[32px] text-[28px] py-1 px-4 rounded-md">
        Tap Tokens Validate Address
      </span>
      <div className="flex flex-col gap-5 w-full max-w-[1000px] mt-5">
        <div className="w-full">
          <Input label="Ticker" type="text" color="white" value={ticker} onChange={(e) => { setTicker(e.target.value)}}/>
        </div>
        <div className="w-full">
          <Input label="Total Amount" type="text" color="white" value={balance} onChange={(e) => { setBalance(e.target.value)}}/>
        </div>
        <div className="w-full">
          <Input label="Decimal" type="text" color="white" value={decimal} onChange={(e) => { setDecimal(e.target.value)}}/>
        </div>
      </div>
      <div className="relative w-full max-w-[1000px]">
        <div className="text-gray-500 ">Address, Amount (Optional)</div>
        {/* <div 
          ref={divRef}
          className="w-full max-w-[1000px] border-[1px] border-solid border-white text-white h-[500px] rounded-md p-2 overflow-auto" 
          contentEditable= "true">
        </div> */}
        <Textarea className="w-full text-white border-white" rows="20" value={textareaText} onChange={(e) => setTextareaText(e.target.value)}/>
        {
          isValid ?
            <img src = {checkImg} className="w-10 h-10 absolute bottom-2 right-2"/>  : <></>
        }
      </div>
      <div className="flex flex-row gap-4">
        <div className= "cursor-pointer px-3 py-2 rounded-md bg-gray-900 hover:bg-gray-800 text-white" onClick={checkValidateAddress}>REMOVE INVALID</div>
        <div className= "cursor-pointer px-9 py-2 rounded-md bg-primary hover:bg-primary-hover text-white" onClick={handleDownload}>Download</div>
      </div>
      {/* {
        addresses.length > 0 ? 
        <div className="text-red-500 text-[20px] w-full max-w-[1000px]">
          {
            addresses.map((address, index) => {
              return <div key={index}>{address}</div>
            } )
          }
        </div>
        :
        <></>
      } */}
    </div>
  )
}
